<template>
  <div class="solutions">
    <!-- Banner区域 -->
    <div class="solutions-bg">
      <div class="solutions-bg-img">
        <img src="@/assets/home/banner.png" alt="Solutions Banner">
      </div>
      <div class="solutions-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('solutions.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('solutions.breadcrumb.activeTitle') }}</li>
          </ol>
        </nav>
      </div>
      <div class="solutions-bg-position">
        <div :class="positionActive == index?'solutions-bg-position-item solutions-bg-position-item-active':'solutions-bg-position-item'" 
             v-for="(item, index) in navList" :key="index" @click="positionClick(index,$event)">
          <a :href="item.id">{{ item.name }}</a>
        </div>
      </div>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
      <div class="solutions-title">
        <h1>{{ $t('home.oneCont.title') }}</h1>
        <p>{{ $t('home.oneCont.cont') }}</p>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="solutions-content">
      <!-- Service标签页内容 -->
      <div class="solutions-service" id="solutions-service" >
        <!-- 顶部标签栏 -->
        <div class="service-tabs">
          <div :class="serviceTabActive == index?'service-tab active':'service-tab'" v-for="(item,index) in solutionsList[0]?.value" :key="index" @click="serviceTabClick(index)">{{ item.title }}</div>
          <!-- <div class="service-tab">Hair</div>
          <div class="service-tab">Nourishing therapy</div>
          <div class="service-tab">Relax</div> -->
        </div>
        
        <!-- 服务网格 -->
        <div class="service-grid">
          <!-- service-item-large oil-control -->
          <div :class="index === 3 || index === 4?'service-item-small':index === 2?'service-item-large':'service-item-large'" v-for="(item, index) in solutionsList[0]?.value[serviceTabActive]?.content" :key="index">
            <div class="service-item-img">
              <img :src="item.subheading_img" alt="" class="service-item-img-img">
            </div>
  
            <div class="service-overlay" @mouseover="handleMouseOver(index)" @mouseleave="handleMouseLeave(index)" :style="item.detail?'transform: translateY(76%);':'transform: translateY(80%);'">
              <div class="service-overlay-bc"></div>
              <h3>{{ item.subheading_title }}</h3>
              <div class="service-overlay-text" v-html="item.detail"></div>
            </div>
          </div>
        </div>
      </div>


      <div class="solutions-efficacyExhibition" id="solutions-efficacyExhibition">
        <div class="solutions-efficacyExhibition-cont">
          <div class="area-solutions-pc">
            <p>{{ solutionsList[1]?.value[0]?.title }}</p>
            <p class="area-titleBottom-pc">{{ solutionsList[1]?.value[0]?.subheading }}</p>
          </div>
          <div class="solutions-efficacyExhibition-img">
            <img :src="solutionsList[1]?.value[0]?.img" alt=""></img>
          </div>
          <div class="solutions-efficacyExhibition-text">
            <!-- <div class="solutions-efficacyExhibition-text-title">
              <h2>{{ solutionsList[1]?.value[0]?.content }}</h2>
            </div> -->
            <div class="solutions-efficacyExhibition-text-content">
              <h4 class="solutions-efficacyExhibition-text-content-description" v-html="solutionsList[1]?.value[0]?.content"></h4>
              <!-- <h4 class="solutions-efficacyExhibition-text-content-description">{{ $t('solutions.efficacy.testDescription') }}</h4>
              <h4 class="solutions-efficacyExhibition-text-content-p solutions-efficacyExhibition-text-content-p-bold">
                {{ $t('solutions.efficacy.usage.title1') }}<span>|</span>{{ $t('solutions.efficacy.usage.title2') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p solutions-efficacyExhibition-text-content-p-bold">
                {{ $t('solutions.efficacy.usage.subtitle1') }}<span>|</span>{{ $t('solutions.efficacy.usage.subtitle2') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p">
                {{ $t('solutions.efficacy.testimonials.beforeAfter') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p">
                {{ $t('solutions.efficacy.testimonials.maxImprovement') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p solutions-efficacyExhibition-text-content-p-bold">
                {{ $t('solutions.efficacy.testimonials.realExperience') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p">
                {{ $t('solutions.efficacy.testimonials.improvement') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p">
                {{ $t('solutions.efficacy.testimonials.results') }}
              </h4>
              <h4 class="solutions-efficacyExhibition-text-content-p">
                {{ $t('solutions.efficacy.testimonials.confidence') }}
              </h4> -->
            </div>
          </div>
        </div>
      </div>


      <!-- Customer Reviews -->
      <div class="customer-reviews">
        <div class="area-oneTitle-pc">
          <p class="area-twoTitle-pc-fontSize">{{ $t('solutions.customerReviews.title') }}</p>
        </div>
        <rolling-barrage></rolling-barrage>
      </div>
    </div>
  </div>
</template>

<script>
import rollingBarrage from '@/components/rollingBarrage.vue'
import { bus } from '@/utils/bus'
import { getBannerListing,getDataList } from '@/api/komo'
export default {
  name: 'solutions',
  components: {
    rollingBarrage
  },
  data() {
    return {
      positionActive: 0,
      serviceTabActive: 0,

      navList: [
        {
          name: this.$t('solutions.tabs.service'),
          id: '#solutions-service'
        },
        {
          name: this.$t('solutions.tabs.efficacy'),
          id: '#solutions-efficacyExhibition'
        }
      ],
      bannerList: [], //
      solutionsList: [],
    }
  },
  async created () {
    await this.initData();
    this.updateServiceTabFromRoute();
  },
  watch: {
    // 监听路由参数中的code变化
    '$route.params.code' (newCode, oldCode) {
      this.updateServiceTabFromRoute();
    }
  },
  methods: {
    updateServiceTabFromRoute () {
      if (this.$route.params.code) {
        this.solutionsList[0]?.value.forEach((item, index) => {
          if (item.code == this.$route.params.code) {
            this.serviceTabActive = index;
          }
        });
      } else {
        this.serviceTabActive = 0;
      }
    },
    serviceTabClick (index) {
      this.serviceTabActive = index;
    },
    positionClick(index,event) {
      this.positionActive = index;
      this.$nextTick(() => {
        const targetId = this.navList[index].id;
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          // 阻止 <a> 标签的默认跳转行为
          if (event) {
            event.preventDefault();
          }
          
          // 计算目标位置
          const offsetTop = targetElement.offsetTop + 100;
          console.log('元素距离文档顶部的位置:', offsetTop);
          // 使用原生平滑滚动
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
          
          // 可选：在滚动完成后添加视觉反馈
          /*
          setTimeout(() => {
            targetElement.style.transition = 'box-shadow 0.5s ease';
            targetElement.style.boxShadow = '0 0 20px rgba(213, 220, 200, 0.8)';
            
            // 2秒后移除高亮效果
            setTimeout(() => {
              targetElement.style.boxShadow = '';
            }, 2000);
          }, 1000);
          */
        }
      });
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
    async initData () {
      const result = await getBannerListing('3');
      this.bannerList = result.data.list;

      const solutionsDatalist = await getDataList(localStorage.getItem('pageId'));
      this.solutionsList = solutionsDatalist.data.list;
    },
    handleMouseOver(index) {
      let imgs = document.querySelectorAll('.service-item-img-img')
      imgs[index].style.filter = 'blur(5px)'
      // console.log('鼠标进入');
    },
    handleMouseLeave(index) {
      // console.log('鼠标离开');
      let imgs = document.querySelectorAll('.service-item-img-img')
      imgs[index].style.filter = 'blur(0px)'
    },
  },
  mounted () { 

  }
}
</script>

<style scoped>
/* 整体样式 */
.solutions {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

/* Banner区域样式 */
.solutions-bg {
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 2%;
}

.solutions-bg-img {
  width: 100%;
  height: 580px;
}

.solutions-bg-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.solutions-bg-breadcrumb {
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}

.solutions-bg-breadcrumb .breadcrumb {
  margin: 0;
  font-size: 1.5rem;
}

.solutions-bg-breadcrumb .breadcrumb a {
  color: #959595;
  text-decoration: none;
}

.solutions-bg-breadcrumb .breadcrumb-item.active {
  font-weight: bold;
  color: #1E1E1E;
}

.solutions-bg-position {
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}

.solutions-bg-position-item {
  padding: 1% 2%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.solutions-bg-position-item a {
  color: #1E1E1E;
  text-decoration: none;
}

.solutions-bg-position-item-active {
  background: #D5DCC866;
  font-weight: bold;
}

.solutions-bg-information {
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}

.solutions-bg-information img {
  width: 100%;
  height: 100%;
}

.solutions-title {
  position: absolute;
  top: 31%;
  left: 9%;
  transform: translateY(-50%);
  color: #000;
  z-index: 1;
}

.solutions-title h1 {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
}

.solutions-title p {
  font-size: 2rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

/* 内容区域样式 */
.solutions-content {
  width: 100%;
  padding: 4% 0 6%;
}

/* Service网格样式 */
.solutions-service {
  width: 80%;
  margin: 0 auto;
}

/* 服务标签栏 */
.service-tabs {
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  margin: 2rem 0;
}

.service-tab {
  padding: 0.8rem 2rem;
  background: transparent;
  border-radius: 25px;
  font-size: 1.1rem;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  border:1px solid #bebebe;
}

.service-tab.active {
  background: #D5DCC866;
  color: #1E1E1E;
  font-weight: 600;
}

.service-tab:hover {
  background: #D5DCC866;
  color: #1E1E1E;
}

/* 服务网格布局 */
.service-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 440px 440px;
  gap: 20px;
  margin-top: 2rem;
}

.service-item-large {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.service-item-small {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.service-item-large:hover,
.service-item-small:hover {
  transform: translateY(-5px);
}

/* 右侧大图片占据整个右侧 */
.oil-control {
  grid-column: 3;
  grid-row: 1 / 3;
}

/* 左下角两个小图片 */
.service-item-small:nth-of-type(4) {
  grid-column: 1;
  grid-row: 2;
}

.service-item-small:nth-of-type(5) {
  grid-column: 2;
  grid-row: 2;
}

.service-item-img {
  width: 100%;
  height: 100%;
  position: relative;
}

.service-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: filter 0.5s ease;
}

/* 覆盖层文字 */
.service-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 2rem 1.5rem 1.5rem;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
  cursor: pointer;
}
.service-overlay:hover{
  transform: translateY(0px)!important;
}
.service-overlay-bc{
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.service-overlay h3 {
  font-size: 1.4vw;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  position: relative;
  z-index: 2;
  text-align: center;
  padding-bottom: 3%;
}
.service-overlay .service-overlay-text{
  font-size: 1.2vw;
  color: #FFFFFF;
  opacity: 1;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 86%;
  font-weight: 100;
  position: relative;
  z-index: 2;
  overflow-y: auto;
  padding: 0 2%;
}

/* 整体滚动条容器 */
.service-overlay .service-overlay-text::-webkit-scrollbar {
  width: 8px;       /* 竖向滚动条宽度 */
  height: 10px;      /* 横向滚动条高度 */
  background: transparent; /* 轨道背景色 */
}

/* 滚动条轨道 */
.service-overlay .service-overlay-text::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  border-radius: 10px;
}

/* 滚动条滑块 */
.service-overlay .service-overlay-text::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 5px;
  border: 2px solid transparent; /* 透明边框增强视觉效果 */
  background-clip: content-box;  /* 避免背景色溢出 */
}

/* 滑块悬停状态 */
.service-overlay .service-overlay-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条角落 */
.service-overlay .service-overlay-text::-webkit-scrollbar-corner {
  background: transparent;
}

/* Efficacy区域样式 */
.solutions-efficacy {
  width: 80%;
  margin: 0 auto;
}

.efficacy-content {
  display: flex;
  gap: 4%;
  margin-top: 3%;
}

.efficacy-images {
  flex: 1;
  display: flex;
  gap: 2%;
}

.efficacy-image-item {
  flex: 1;
  height: 400px;
}

.efficacy-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.efficacy-diary {
  flex: 1;
  background: #F0F0F0;
  padding: 2rem;
  border-radius: 20px;
}

.efficacy-diary h3 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #1E1E1E;
  margin-bottom: 1rem;
  text-align: center;
}

.efficacy-description {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.usage-comparison {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.usage-item {
  text-align: center;
}

.usage-title {
  font-weight: bold;
  font-size: 1.1rem;
  color: #1E1E1E;
  margin-bottom: 0.5rem;
}

.usage-subtitle {
  font-size: 1rem;
  color: #666;
}

.testimonials p {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.8rem;
}

.real-experience {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: #1E1E1E;
  margin: 1.5rem 0;
}


.solutions-efficacyExhibition{
  width: 100%;
  height: 100%;
  background: #D5DCC880;
  margin-top: 5%;
  padding-bottom: 5%;
}
.solutions-efficacyExhibition-cont{
  width: 80%;
  margin: 0 auto;
}
.solutions-efficacyExhibition-img{

}
.solutions-efficacyExhibition-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.solutions-efficacyExhibition-text{
  padding-top: 3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
}
.solutions-efficacyExhibition-text-title{
  color: #64715D;
  font-weight: bold;
}
.solutions-efficacyExhibition-text-content{
  font-family: MicrosoftYaHei;
  color: #1E1E1E;
}
.solutions-efficacyExhibition-text-content h4{
  margin-bottom: 1.8rem;
  font-weight: 300;
  line-height: 2;
}
.solutions-efficacyExhibition-text-content-p-bold{
  font-weight: 600!important;
}
.solutions-efficacyExhibition-text-content-p span{
  margin: 0 1%;
}


/* Customer Reviews样式 */
.customer-reviews {
  width: 80%;
  margin: 6% 0 0 0;
  padding: 0% 0 4%;
  overflow: hidden;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 30px;
}

.customer-reviews .area-title-pc {
  margin-bottom: 3rem;
}

/* 通用标题样式 */
.area-title-pc {
  text-align: center;
  margin-bottom: 2rem;
}

.area-title-pc p {
  font-size: 2.5rem;
  font-weight: bold;
  color: #1E1E1E;
  margin: 0;
}

.area-titleBottom-pc {
  font-size: 1.5rem !important;
  color: #666 !important;
  font-weight: normal !important;
  margin-top: 0.5rem !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .service-grid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 250px 250px 250px;
  }
  
  .oil-control {
    grid-column: 1 / 3;
    grid-row: 3;
  }
  
  .service-item-small:nth-of-type(4) {
    grid-column: 1;
    grid-row: 2;
  }

  .service-item-small:nth-of-type(5) {
    grid-column: 2;
    grid-row: 2;
  }
  
  .efficacy-content {
    flex-direction: column;
  }
  
  .efficacy-images {
    margin-bottom: 2rem;
  }
}

@media (max-width: 768px) {
  .service-tabs {
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .service-tab {
    padding: 0.6rem 1.5rem;
    font-size: 1rem;
  }
  
  .service-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, 200px);
    gap: 15px;
  }
  
  .oil-control {
    grid-column: 1;
    grid-row: 3;
  }
  
  .service-item-small:nth-of-type(4) {
    grid-column: 1;
    grid-row: 4;
  }

  .service-item-small:nth-of-type(5) {
    grid-column: 1;
    grid-row: 5;
  }
  
  .service-overlay {
    padding: 1.5rem 1rem 1rem;
  }
  
  .service-overlay h3 {
    font-size: 1.2rem;
  }
  
  .review-item {
    height: 50px;
    padding: 0.6rem 1rem;
  }
  
  .review-avatar {
    width: 35px;
    height: 35px;
  }
  
  .review-content h4 {
    font-size: 0.8rem;
  }
  
  .review-content p {
    font-size: 0.75rem;
  }
  
  .reviews-row {
    height: 60px;
  }
  
  .solutions-title h1 {
    font-size: 2.5rem;
  }
  
  .solutions-title p {
    font-size: 1.2rem;
  }
}
</style>
